import { clog } from "./common";

// paypal_sdk object is created from the official sdk js file placed in the view _paypal_button.php

// #paypal_button is in checkout page,
// #paypal_button_1 and #paypal_button_2 are in cart page
[ '#paypal_button', '#paypal_button_1', '#paypal_button_2' ].forEach(function(selector) {

    if($(selector).length > 0)
    {
        paypal_sdk.Buttons({
            style: paypal_style,
        
            createOrder: function(data, actions) {
                // This function sets up the details of the transaction, including the amount and line item details.
                return actions.order.create({
                    purchase_units: paypal_purchase_units
                });
            },
        
            onApprove: function(data, actions) {
                document.getElementById('loading-bodyclick').style.display = 'block';
        
        
                // This function captures the funds from the transaction.
                return actions.order.capture().then(function(details) {
                    //                console.log(details);
                    clog("paypal_transaction_ok", details);
                    let json_body = JSON.stringify({
                        details
                    });

                    $.ajax({
                        contentType: 'application/json',
                        data: json_body,
                        dataType: 'json',
                        success: function(data){
                            if (data.status == 'ok') {
                                window.location.href = data.redirect_url;
                            } else {
                                clog("paypal_transaction_ok_not_received_1", {data: data, details: details});
                                alert("There was an error with your order. Please try again or contact us.");
                                location.reload(); 
                            }
                        },
                        error: function(error){
                            clog("paypal_transaction_ok_not_received_2", {error: error, data: details});
                            alert("There was an error with your order. Please try again or contact us.");
                            location.reload(); 
                        },
                        processData: false,
                        type: 'POST',
                        url: paypal_confirm_url
                    });
                    

                    /*

                    // This function shows a transaction success message to your buyer.
                    //alert('Transaction completed by ' + details.payer.name.given_name);
                    var req = new Request( paypal_confirm_url , {
                        method: "post",
                        headers: new Headers({
                            "Content-Type": "application/json"
                        }),
                        body: json_body
                    });
        
                    fetch(req)
                        .then((response) => response.json())
                        .then(function(data) {
                            //console.log(data);
                            if (data.status == 'ok') {
                                window.location.href = data.redirect_url;
                            } else {
                                clog("paypal_transaction_ok_not_received_1", {data: data, details: details});
                                alert("There was an error with your order. Please try again or contact us.");
                                location.reload(); 
                            }
                        }).catch((error) => {
                            clog("paypal_transaction_ok_not_received_2", {error: error, data: details});
                            alert("There was an error with your order. Please try again or contact us.");
                            location.reload(); 
                        });
                    */
                   
                });
            },
        
            onCancel: function(data) {
                // Show a cancel page, or return to cart
                location.reload();
            },
        
            onError: function(err) {
                document.getElementById('loading-bodyclick').style.display = 'none';
                // Show an error page here, when an error occurs
                //console.log(err);
                clog("paypal_transaction_error", err);
        
                //alert('There was an error with Paypal. Please try again or contact us at change@photocircle.net');
                //location.reload();
            },
        
            onShippingChange: function(data, actions) {
        
                // If user changes the country from the paypal window, reject the request
                // because the shipping costs and the total to pay could be different
                // It is a temporary solution.
                // What we should do next, is to use the final example of this page:
                // https://developer.paypal.com/docs/checkout/integration-features/shipping-callback/ 
                if (data.shipping_address.country_code !== paypal_shipping_country_code) {
                    return actions.reject();
                }
        
                return actions.resolve();
            }
        }).render(selector);
    }
});
